import { z } from 'zod'
import { settlementRoundResponseSchema } from './settlement-round-response.schema'

export const debtEntrySchema = z.object({
  fromUserId: z.string().guid(),
  fromUserName: z.string(),
  toUserId: z.string().guid(),
  toUserName: z.string(),
  amount: z.number(),
  currency: z.string(),
})

export type DebtEntryDto = z.infer<typeof debtEntrySchema>

export const debtSummaryResponseSchema = z.object({
  debts: z.array(debtEntrySchema),
  // expenses dropped from the debt calc because their currency could not be converted to the base
  // (no resolvable rate) — surfaced so the UI can warn instead of silently under/over-counting. never
  // valued at a 1:1 parity fallback.
  excludedExpenseCount: z.number().int().nonnegative().default(0),
  activeRound: settlementRoundResponseSchema.nullable(),
})

export type DebtSummaryResponseDto = z.infer<typeof debtSummaryResponseSchema>
